<template>
    <!--
      	作者：bbc_team
      	时间：2023-06-08
      	描述：供货商-列表
      -->
    <div>
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="供货商名称"><el-input v-model="searchForm.supplier_name" size="small" placeholder="请输入供货商名称"></el-input></el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="common-level-rail">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="addSupplier">添加供货商</el-button>

        </div>
        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="supplier_id" label="供货商ID" width="100"></el-table-column>
                <el-table-column prop="supplier_name" label="供货商名称">
                    <template slot-scope="scope">
                        <div class="text-ellipsis" :title="scope.row.supplier_name">{{ scope.row.supplier_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="link_user" label="联系人" width="100"></el-table-column>
                <el-table-column prop="tel" label="联系电话" width="100"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="green">显示</span>
                        <span v-if="scope.row.status == 0" class="gray">隐藏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
                <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
                <el-table-column prop="name" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editAd(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteAd(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import SupplierApi from "@/api/supplier.js";
    export default {
        components: {},
        data() {
            return {
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                commentData: [],
                loading: true,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*搜索参数*/
                searchForm: {
                    supplier_name: "",
                },
            };
        },
        created() {
            /*获取供货商列表*/
            this.getData();
        },
        methods: {
            /*获取供货商列表*/
            getData() {
                let self = this;
                let Params = self.searchForm;
                Params.page = self.curPage;
                SupplierApi.SupplierList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },
            /*搜索查询*/
            onSubmit() {
                this.curPage = 1;
                this.getData();
            },
            /*添加供货商*/
            addSupplier() {
                this.$router.push({
                    path: "/supplier/supplier/add"
                });
            },

            /*编辑供货商*/
            editAd(row) {
                let params = row.supplier_id;
                this.$router.push({
                    path: "/supplier/supplier/edit",
                    query: {
                        supplier_id: params
                    }
                });
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },

            /*删除供货商*/
            deleteAd(row) {
                let self = this;
                self.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        self.loading = true;
                        SupplierApi.deleteSupplier(
                            {
                                supplier_id: row.supplier_id
                            },
                            true
                        )
                            .then((data) => {
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.loading = false;
                                self.getTableList();
                            })
                            .catch((error) => {});
                    })
                    .catch(() => {});
            },

            handleClick(tab, event) {},

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == "add") {
                    this.open_add = e.openDialog;
                    if (e.type == "success") {
                        this.getTableList();
                    }
                }
                if (f == "edit") {
                    this.open_edit = e.openDialog;
                    if (e.type == "success") {
                        this.getTableList();
                    }
                }
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/index.vue